export default __webpack_public_path__ + "static/media/NishantBhasin.41022362.jpg";